import * as React from 'react'

import { cn } from '@/utils/shadcn'

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  parentClassName?: string
}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, parentClassName, children, ...props }, ref) => {
    return (
      <div className={cn('relative', parentClassName)}>
        {children && (
          <div className='absolute left-[13px] top-[14px] text-[#71717A]'>
            {children}
          </div>
        )}
        <input
          type={type}
          className={cn(
            'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
            children && 'pl-8',
            className
          )}
          ref={ref}
          {...props}
        />
      </div>
    )
  }
)
Input.displayName = 'Input'

export { Input }
